import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, TimelineLite, TimelineMax, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import {ch5_p01} from "../../../layouts/ch5_p01/ch5_p01";

export class Chapter5Page1 extends AbstractStoryState {

    readonly bg = this.addChild(new SceneSprite());
    readonly hollyBack = this.addChild(new SceneSprite());
    // tslint:disable-next-line: variable-name
    readonly penSide_closed = this.addChild(new SceneSprite());
    readonly hollyFront = this.addChild(new SceneSprite());
    readonly penFront = this.addChild(new SceneSprite());
    // tslint:disable-next-line: variable-name
    readonly penSide_open = this.addChild(new SceneSprite());
    readonly holly = this.addChild(new SceneSprite());

    readonly lamb = list(()=>this.addChild(new SceneSprite()));

	readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch5_p01/"));
	readonly frameRight = this.addChild(SceneSprite.withPrefix("ch5_p01/"));
	readonly linesLeft = this.addChild(SceneSprite.withPrefix("ch5_p01/"));
	readonly linesRight = this.addChild(SceneSprite.withPrefix("ch5_p01/"));

    public init(pSize: PIXI.Point, pData: any) {
		// exported layouts from Animate CC
        ch5_p01.call(this);

        this.setChildIndex(this.lamb[0], this.getChildIndex(this.hollyBack) + 1);
        this.setChildIndex(this.lamb[1], this.getChildIndex(this.hollyFront) + 1);

        this.holly.visible = false;
        this.penSide_open.visible = false;
        this.lamb[1].visible = false;

        this.bg.z = 5;
        this.linesRight.z = 5;
        this.hollyBack.z = 4;
        this.hollyFront.z = 4;
        this.penSide_closed.z = 3;
        this.lamb[0].z = 3;
        this.penFront.z = 2;
        this.linesLeft.z = 2;

        this.makeParallax([
            this.bg,
            this.linesRight,
            this.hollyBack,
            this.penSide_closed,
            this.lamb[0],
            this.hollyFront,
            this.penFront,
            this.linesLeft,
        ], {
            duration: 4,
            distance: 8,
            spread: 10,
        });

		// super.init calls onResize
		super.init(pSize, pData);
	}

	public update(pDeltaTime: number) {
		super.update(pDeltaTime);
	}

	public animateIn(pOnComplete: ()=>void) {
        super.animateIn(pOnComplete);

        const intro = HLF.Application.instance.audio.createAudioTrack("HH_Ch5_Intro_P1", HLF.AudioCategory.BGM);
        const mainLoop = HLF.Application.instance.audio.createAudioTrack("HH_Ch5_LoopA_P1-5", HLF.AudioCategory.BGM);
        mainLoop.setLooped(true);
        intro.once(HLF.HowlerUtils.Events.END, ()=>{
            mainLoop.play();
			intro.unloadSource();
        });
        intro.play();
    }

    public animateOut(pOnComplete: ()=>void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        new TimelineLite()
            .call(()=>{
                this.lamb[0].FadeOut();
                this.hollyBack.FadeOut();
                this.hollyFront.FadeOut();
                this.penSide_closed.FadeOut();

                this.penSide_open.FadeIn();
                this.lamb[1].FadeIn();
                this.holly.FadeIn();
            }, undefined, undefined, 1.5)
            .call(()=>{
                super.onAnimateInComplete();
            }, undefined, undefined, "+=1.5")
            .call(()=>{
                this.gotoNextState({transition: "left"});
            }, undefined, undefined, "+=1.5")
        ;
    }
}